module.exports = __webpack_public_path__ + "static/img/73.a749949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/73.png
// module id = +BgC
// module chunks = 0